var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22.234,
    viewBox: "0 0 26 22.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M12.391,44.277l.564.609.609-.608a7.388,7.388,0,0,1,6.373-2.027A7.257,7.257,0,0,1,26,49.411v.295a7.6,7.6,0,0,1-2.417,5.561l-9.176,8.567a2.064,2.064,0,0,1-2.813,0L2.417,55.266A7.6,7.6,0,0,1,0,49.706v-.295a7.259,7.259,0,0,1,12.391-5.134c-.046,0,0,0,0,0Zm.564,4.057-2.285-2.377a4.928,4.928,0,0,0-4.2-1.3,4.822,4.822,0,0,0-4.027,4.756v.295A5.164,5.164,0,0,0,4.08,53.484L13,61.812l8.922-8.328a5.168,5.168,0,0,0,1.64-3.778v-.295a4.824,4.824,0,0,0-4.027-4.756,4.928,4.928,0,0,0-4.2,1.3Z",
    transform: "translate(0 -42.152)",
    fill: "#777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.7c7acfd0f4616fcbebd46a077f0efe38.svg";
export { ForwardRef as ReactComponent };